import { customerWaiverModel } from './customer-waivers-model'

export const customerWaiverShortView = customerWaiverModel.pick({
  id: true,
  email: true,
  firstName: true,
  lastName: true,
  waiverFormSnapshotUrl: true
})
